<template>
  <div class="paddedPage" style="align-items: center; justify-content: center;">
    <template v-if="showFilePicker">
      <Button v-if="showingDownloadLatestVersion" :disabled="!enableDownloadLatestVersion" severity="secondary" @click="downloadLatestVersion()">
        Download latest 
        <span v-if="latestVersion"  style="font-family: consolas; font-size: small;">
          ({{ latestVersion }})
        </span>
      </Button>
      <div>
        Currently running version
        {{ store.sessions[0].system.programVersionMajor.value }}.{{ store.sessions[0].system.programVersionPatch.value }}
      </div>
      <div v-if="!showingDownloadLatestVersion">
        No newer versions available online.
      </div>
      <form ref="form" enctype="multipart/form-data" style="display: flex; align-items: center; gap: 10px;">
        <input class="p-inputtext" type="file" name="newFile" @change="onFileSelected($event.target.value)">
        <Button severity="secondary" :disabled="filename == null || isInvalidFile()" @click="onClickUpload()">
          Upload
        </Button>
        <span v-if="isInvalidFile()" style="color: firebrick;">
          Invalid file. Expecting Mvv2-v123.zip
        </span>
      </form>
    </template>
    <template v-else>
      <h3>
        {{ progressMessage }}
      </h3>
      {{ progressMessage_detail }}
      <progress ref="progress" v-bind="progressBarAttributes" style="width: 100%;"></progress>
    </template>
  
    <template v-if="showInstall">
      <div style="display: flex; gap: 10px;">
        <Button @click="install()">
          Install
        </Button>
        <Button severity="secondary" @click="cancel()">
          Cancel
        </Button>
      </div>
    </template>
  </div>
</template>

<script>
import store from "./store.js";

export default {
  data() {
    return {
      store,
      filename: null,
      showFilePicker: true,
      showInstall: false,
      progressMessage: null,
      progressMessage_detail: null,
      progressPercent: null,
    }
  },
  computed: {
    latestVersionNumber() {
      return store.sessions[0].system.programUpgradeVersion.value
    },
    latestVersion() {
      return this.latestVersionNumber ? `Mvv2-v${this.latestVersionNumber}.zip` : null;
    },
    showingDownloadLatestVersion() {
      return !this.filename && this.latestVersionNumber > store.sessions[0].system.programVersionMajor.value;
    },
    enableDownloadLatestVersion() {
      return this.latestVersionNumber > store.sessions[0].system.programVersionMajor.value;
    },
    progressBarAttributes() {
      return {
        max: 100,
        value: this.progressPercent == null ? undefined : this.progressPercent
      };
    }
  },
  async mounted() {
    this.$refs.form.addEventListener("submit", this.onSubmitUploadForm);
  },
  methods: {
    async downloadLatestVersion() {
      // Download the latest version, in a manner that avoids triggering the webview's navigation event handlers.
      this.showFilePicker = false;
      this.progressMessage = `Downloading ${this.latestVersion}`;
      this.progressMessage_detail = "";
      let response = await fetch(`http://fileserver.gormancontrols.com:2999/Mvv2/${this.latestVersion}`, { mode: "cors" });
      let totalBytes = parseInt(response.headers.get('Content-Length'), 10);
      let reader = response.body.getReader();
      let receivedBytes = 0;
      let chunks = [];
      while (true) {
        let { done, value } = await reader.read();
        if (done) {
          break;
        }
        else {
          chunks.push(value);
          receivedBytes += value.length;
          let progress = receivedBytes / totalBytes;
          this.progressPercent = Math.round(progress * 100);
        }
      }
      let blob = new Blob(chunks);
      let fileName = this.latestVersion;
      let fileFormData = new FormData();
      fileFormData.append("file", blob, fileName)
      this.progressMessage = `Uploading ${this.latestVersion}`;
      this.progressMessage_detail = "";
      this.uploadFile(fileName, fileFormData);
    },
    onFileSelected(path) {
      let index = path.lastIndexOf("\\");
      this.filename = path.substring(index + 1);
    },
    isInvalidFile() {
      return this.filename && !this.filename.match(/Mvv2-v\d+.zip/);
    },
    onClickUpload() {
      this.$refs.form.requestSubmit();
    },
    onSubmitUploadForm(submitEvent) {
      this.showFilePicker = false;
      this.progressMessage = `Uploading ${this.filename}...`;
      this.uploadFile(this.filename, new FormData(submitEvent.target));
      submitEvent.preventDefault();
    },
    uploadFile(fileName, fileFormData) {
      let request = new XMLHttpRequest();
      request.open('POST', "/cmd/uploadProgram", true);
      request.upload.addEventListener('progress', progressEvent => {
        this.progressPercent = Math.min(100, parseInt(progressEvent.loaded / progressEvent.total * 100));
      });
      let self = this;
      request.onload = () => {
        if (request.status >= 200 && request.status < 300) {
          self.progressMessage = `Uploaded ${fileName}.`;
          self.showInstall = true;
        }
        else {
          self.progressMessage = `Upload failed (${request.status})`;
          alert(`Upload failed: ${request.status} ${request.statusText}`);
          self.progressPercent = 0;
        }
      };
      request.onerror = () => {
        alert("Upload failed");
        this.progressPercent = 0;
      };
      request.send(fileFormData);
    },
    cancel() {
      // For some reason, trying to submit a second file after cancelling just reloads the page.
      // Reloading the page after cancelling prevents that.
      window.location.reload();
    },
    install() {
      this.progressMessage = "Installing ...";
      this.showInstall = false;
      this.progressPercent = null;
      let session = store.sessions[0];
      session.queueRequest("/cmd/installProgram", null, () => {
        this.progressMessage = "Rebooting ...";
        this.progressMessage_detail = "This may take a few minutes";
        session.queueRequest("/cmd/reboot-step1");
        session.queueRequest("/cmd/reboot-step2", { programUpgrade: true });
      });
    }
  }
}
</script>

<style scoped>
#progress-bar {
  width:0%;
  height: 33px;
  padding: 5px;
  background-color: lawngreen;
}
</style>